import React, { useEffect } from "react";

const Popup = ({isDesktop, adIds, popUpType, domain }) => {

    if (!adIds) {
        return null;
    }

    const adId = typeof adIds === 'object' && adIds !== null
    ? (isDesktop ? adIds.pc : adIds.mob)
    : adIds;

    if (!adId) {
        return null;
    }

    useEffect(() => {
        const scriptEl = document.createElement("script");
        scriptEl.async = true;
        scriptEl.src = 'https://showsclick.com/pops.js';
        scriptEl.addEventListener('load', function () {
            ytrgt.popunder.init({
                href: `https://${domain}/widget.html?block_id=${adId}`,
                mode: popUpType,
                refs: [],
                selector: "a",
                frequency: 1
            });
        });
        document.body.append(scriptEl);

        // Clean up on unmount
        return () => {
            if (scriptEl.parentNode) {
                scriptEl.parentNode.removeChild(scriptEl);
            }
        };
    }, [adId, popUpType]);

    return null;
};

export default Popup;
